module.exports = __webpack_public_path__ + "img/48.be622c76.svg";